import { VOMelodyInstrument, VOMelodyInstrumentMode, VOMelodyNote } from "../model/DataStructure.js";
import { MelodyPlayerListener } from "./MelodyPlayer.js";
import { Sound } from "./Sound.js";

export interface VirutalInstrumentOptions {
    data: VOMelodyInstrument;
    mode?: VOMelodyInstrumentMode;
}

export class VirtualInstrument implements MelodyPlayerListener {

    private _tones: { [note: string]: Sound } = {};
    private _options: VirutalInstrumentOptions;
    private _mode: VOMelodyInstrumentMode = "generative";
    private _synth: Tone.Sampler;

    constructor(options: VirutalInstrumentOptions) {
        this._options = e5.object.merge({
            mode: options.data.mode
        }, options);

        this._mode = this._options.mode;

        for (var t of options.data.tones) {
            this._tones[t.note] = t.sound;
        }

        var urls: { [note: string]: AudioBuffer } = {};
        for (var t of this._options.data.tones) {
            urls[t.note] = t.sound.buffer;
        }
        this._synth = new Tone.Sampler({
            urls: urls,
            release: 4
        }).toDestination();

        // console.log(options.data.title, Object.keys(this._tones).join(" "));
    }

    public attack(note: string, velocity: number = 0.5): void {
        this._synth.triggerAttack(note, Tone.Transport.seconds + 0.05, velocity);
    }

    public release(note: string): void {
        this._synth.triggerRelease(note, Tone.Transport.seconds + 0.05);
    }

    public trigger(note: VOMelodyNote, notes: VOMelodyNote[], time: number = 0): void {
        if (time === 0) {
            time = Tone.Transport.seconds + 0.05;
        }
        if (this._mode === "simple_single") {
            this.playSimple(note, time, true);
        } else if (this._mode === "simple_multi") {
            this.playSimple(note, time, false);
        } else if (this._mode === "generative") {
            this.playSynth(note, time);
        }
    }

    private playSynth(note: VOMelodyNote, time: number): void {
        this._synth.triggerAttackRelease(note.name, note.dur, time, note.velocity);
    }

    private playSimple(note: VOMelodyNote, time: number, killOld: boolean): void {
        if (!this._tones[note.name]) {
            // console.warn("Note for instrument not found:", this._options.data.id, this._options.data.name, note);
            // return;

            var dist = Number.MAX_VALUE;
            var tn = "";
            for (var n in this._tones) {

                var d = this.tonalDistance(note.name, n);
                if (d < dist) {
                    dist = d;
                    tn = n;
                }
            }

            if (tn && this._tones[tn]) {
                this._tones[tn].once(killOld, time);
                console.warn("Note for instrument not found:", this._options.data.title, dist, note, "=>", tn);
                return;
            } else {
                // console.warn("Note for instrument not found:", this._options.data.title, dist, note, "=>", tn);
                return;
            }
        }

        this._tones[note.name].once(killOld, time);
    }

    private tonalDistance(a: string, b: string): number {
        var af = new Tone.Frequency(a);
        var bf = new Tone.Frequency(b);
        return Math.abs(af.toMidi() - bf.toMidi());
        // return Math.abs(af.toFrequency() - bf.toFrequency());
    }
}